import { createApi } from "@reduxjs/toolkit/query/react";
import { prepareBaseQuery } from "./baseQueryWithReauth";

const integrationsApi = createApi({
  reducerPath: "integrations",
  baseQuery: prepareBaseQuery("/integrations/"),
  endpoints: (builder) => ({
    getGoogleOAuthUrl: builder.mutation({
      query: ({ returnTo } = {}) => ({
        url: "google/oauth2/url",
        method: "GET",
        ...(returnTo ? { params: { returnTo } } : {}),
      }),
    }),
  }),
});

export const { useGetGoogleOAuthUrlMutation } = integrationsApi;

export default integrationsApi;
export { integrationsApi };
